import React from 'react'
import { SVGIconName } from '../../../svgIcons'

type SVGIconProps = {
  id: SVGIconName
  size?: number
  width?: number
  height?: number
  className?: string
}

export const SVGIcon = (props: SVGIconProps) => {
  const { className, id, size, width, height } = props
  return (
    <svg className={className || ''} width={width || size || 24} height={height || size || 24} aria-hidden="true">
      <use xlinkHref={`#${id}`} />
    </svg>
  )
}
